import {forwardRef, useEffect, useState} from 'react';

import {IconButton} from '@mui/material';
import Box from '@mui/material/Box';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import '@plannel/scss/components/CustomHeader.scss'

const HEADER_GROUP_EXPANDED = 'headerGroupExpanded';
const HEADER_GROUP_COLLAPSED = 'headerGroupCollapsed';

const CustomHeaderGroup = forwardRef((props, _) => {
  const { columnGroup, setExpanded, displayName, onExpandStateChange } = props;
  const [expandState, setExpandState] = useState(columnGroup.getProvidedColumnGroup().isExpanded() ? HEADER_GROUP_EXPANDED : HEADER_GROUP_COLLAPSED);
  
  const expandOrCollapse = () => {
    const currentState = columnGroup.getProvidedColumnGroup().isExpanded();
    setExpanded(!currentState);

    if (onExpandStateChange) {
      onExpandStateChange(!currentState)
    }
  };

  const syncExpandButtons = () => {
    const newExpandState = columnGroup.getProvidedColumnGroup().isExpanded()
      ? HEADER_GROUP_EXPANDED
      : HEADER_GROUP_COLLAPSED;
    setExpandState(newExpandState);

    if (onExpandStateChange) {
      onExpandStateChange(newExpandState === HEADER_GROUP_EXPANDED);
    }
  };

  const HeaderIcon = () => {
    return (
      <IconButton aria-label="collapsed" size="small" onClick={expandOrCollapse}>
        {expandState === HEADER_GROUP_COLLAPSED
          ? <ArrowForwardIosIcon color="primary" sx={{ml : 1, fontSize : "14px"}} />
          : <ArrowBackIosIcon color="error" sx={{ml : 1, fontSize : "14px"}} />} 
      </IconButton>
    )
  }

  useEffect(() => {
    columnGroup
      .getProvidedColumnGroup()
      .addEventListener('expandedChanged', syncExpandButtons);

    return () => {
      columnGroup
        .getProvidedColumnGroup()
        .removeEventListener('expandedChanged', syncExpandButtons);
    };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="ag-header-group-cell-label">
      <Box className="customHeaderLabel">{displayName}</Box>
      <HeaderIcon/>
    </Box>
  );
});

export default CustomHeaderGroup;